<template>
  <div
    class="frisbuy-customer-review"
    :class="{
      'frisbuy-customer-review--modal-popup': isPopupReview,
      'frisbuy-customer-review--modal-popup-expanded':
        isPopupReview && isReadMoreExpanded,
    }"
    @click="onReviewClick"
  >
    <div
      :class="{
        'frisbuy-customer-review__content-main': !isPopupReview,
        'frisbuy-customer-review__content-main-modal-popup': isPopupReview,
        'frisbuy-customer-review__content-main-modal-popup--collapsed':
          isPopupReview && isOverflowContent && !isReadMoreExpanded,
        'frisbuy-customer-review__content-main-modal-popup--expanded':
          isPopupReview && isReadMoreExpanded,
      }"
      ref="contentMainRef"
    >
      <div class="frisbuy-customer-review__top-section">
        <ReviewAuthor
          :customerName="props.customerName"
          :reviewDate="props.reviewDate"
          :rating="props.rating"
          :isSoftStarIcon="props.isSoftStarIcon"
          :avatarColorIndex="props.avatarColorIndex"
          :view="props.authorView"
        />
        <slot name="topRight"></slot>
      </div>

      <div
        v-if="props.positiveComment || props.negativeComment || props.text"
        class="frisbuy-customer-review__text"
      >
        <div
          v-if="props.positiveComment"
          class="frisbuy-customer-review__text--positive"
          :class="{
            'frisbuy-customer-review__text-block--clamped':
              !isPopupReview && !isReadMoreExpanded,
          }"
          ref="positiveTextRef"
        >
          <span class="frisbuy-customer-review__text--prefix">
            Преимущества:
          </span>

          <span>
            {{ props.positiveComment }}
          </span>
        </div>

        <div
          v-if="props.negativeComment"
          class="frisbuy-customer-review__text--negative"
          :class="{
            'frisbuy-customer-review__text-block--clamped':
              !isPopupReview && !isReadMoreExpanded,
          }"
          ref="negativeTextRef"
        >
          <span class="frisbuy-customer-review__text--prefix">
            Недостатки:
          </span>

          <span> {{ props.negativeComment }} </span>
        </div>

        <div
          v-if="props.text"
          class="frisbuy-customer-review__text--comment"
          :class="{
            'frisbuy-customer-review__text-block--clamped':
              !isPopupReview && !isReadMoreExpanded,
          }"
          ref="commentTextRef"
        >
          <span> {{ props.text }} </span>
        </div>
      </div>
    </div>

    <button
      v-if="isOverflowContent && !isReadMoreExpanded"
      class="frisbuy-customer-review__read-more"
      type="button"
      @click.stop="
        isReadMoreExpanded = true;
        if (isPopupReview) emit('popupReadMoreToggle', true);
      "
    >
      Читать далее
    </button>

    <button
      v-if="isPopupReview && isOverflowContent && isReadMoreExpanded"
      class="frisbuy-customer-review__read-more frisbuy-customer-review__read-more--hide"
      type="button"
      @click.stop="
        isReadMoreExpanded = false;
        emit('popupReadMoreToggle', false);
      "
    >
      Скрыть
    </button>

    <div
      v-if="props.isShowMedia && props.mediaList && props.mediaList.length > 0"
      class="frisbuy-customer-review__media-section"
    >
      <MediaList
        :mediaList="props.mediaList"
        mediaAspectRatio="1 / 1"
        gap="8px"
        wrap="wrap"
        mediaWidth="48px"
        :maxMediaItems="3"
        isShowCountBlock
        @selectMedia="(media) => selectPostWithPhoto(media)"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
$text-color-primary: #212121;
$text-color-secondary: #606266;

.frisbuy-customer-review {
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  display: flex;
  flex-direction: column;
  cursor: pointer;

  .frisbuy-customer-review__content-main-modal-popup {
    width: 100%;
    cursor: pointer;

    @media only screen and (max-width: 1024px) {
      padding: 16px;
    }
  }

  .frisbuy-customer-review__content-main {
    width: 100%;
    cursor: pointer;
  }

  .frisbuy-customer-review__text {
    color: $text-color-primary;

    font-size: 14px;
    font-weight: 400;
    line-height: 20px;

    margin-top: 20px;

    margin-top: 8px;

    & > *:not(:first-child) {
      margin-top: 8px;
    }
  }
}

.frisbuy-customer-review__media-section {
  display: block;
  margin-top: 24px;
}

.frisbuy-customer-review--modal-popup {
  cursor: default;
  height: 500px;

  .frisbuy-customer-review__content-main-modal-popup {
    max-height: none;
  }

  .frisbuy-customer-review__content-main-modal-popup--collapsed {
    position: relative;
    max-height: 432px;
    overflow: hidden;

    &::after {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 40px;
      pointer-events: none;
      background: linear-gradient(
        0deg,
        #ffffff 0%,
        rgba(255, 255, 255, 0) 100%
      );
    }
  }

  .frisbuy-customer-review__content-main-modal-popup--expanded {
    max-height: none;
    overflow: visible;
    padding-right: 0;
  }

  .frisbuy-customer-review__read-more {
    border: 0;
    border-bottom: 1px dashed #212121;
    background: transparent;
    color: #212121;
    cursor: pointer;
    width: fit-content;
    padding: 0;
    margin-top: 8px;
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    font-family: Gilroy, "Segoe UI", Arial, sans-serif;
  }

  .frisbuy-customer-review__read-more-gradient {
    display: none;
  }

  .frisbuy-customer-review__media-section {
    margin-top: auto;
    padding-top: 20px;
  }
}

.frisbuy-customer-review--modal-popup-expanded {
  height: auto;
  min-height: 500px;

  .frisbuy-customer-review__media-section {
    margin-top: 20px;
    padding-top: 0;
  }
}

.frisbuy-customer-review__text--prefix {
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  color: var(--frisbuy-color-primary);
}

.frisbuy-customer-review__text-block--clamped {
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
}

.frisbuy-customer-review__read-more {
  border: 0;
  border-bottom: 1px dashed #212121;
  background: transparent;
  color: #212121;
  cursor: pointer;
  width: fit-content;
  padding: 0;
  margin-top: 8px;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400;

  &:hover {
    color: #00b9bf;
    border-bottom-color: #00b9bf;
  }
}
</style>

<script setup lang="ts">
import MediaList from "./MediaList.vue";
import ReviewAuthor from "./ReviewAuthor.vue";
import { imageWithPostId, postMedia } from "../interfaces";
import {
  computed,
  nextTick,
  onBeforeMount,
  onMounted,
  onBeforeUnmount,
  ref,
  watch,
} from "vue";
import { addSchemaToPage } from "@/common/services/SchemaOrg/SchemaOrg";

//#region Schema.org
onBeforeMount(() => {
  props.mediaList?.forEach((media) => {
    media.linkList.forEach((link) => {
      const Product = link;
      const bestRating = 5;
      // NOTE: if ratingValue === 0 and worstRating === 1, then it will be error
      const worstRating = 1;
      if (!Product) {
        return;
      }

      /* NOTE:
        Google always need to get `ratingValue` and `reviewCount`.
        But sometimes this information may not be available
      */
      if (
        !Product.sku ||
        !Product.sku?.avgRating ||
        !Product.sku?.reviewsCount
      ) {
        return;
      }

      const reviewRating =
        props.rating && props.rating > 0 ? props.rating : bestRating;

      const SchemaorgProduct = {
        "@context": "https://schema.org",
        "@type": "Product",
        name: Product.title,
        aggregateRating: {
          "@type": "AggregateRating",
          ratingValue: Product.sku.avgRating,
          bestRating: bestRating,
          worstRating: worstRating,
          reviewCount: Product.sku.reviewsCount,
        },

        review: [
          {
            "@type": "Review",

            author: {
              "@type": "Person",
              name: props.customerName,
            },
            datePublished: props.reviewDate,
            reviewBody: `${props.text}\n${props.positiveComment}\n${props.negativeComment}`,

            reviewRating: {
              "@type": "Rating",
              bestRating: bestRating,
              ratingValue: reviewRating,
              worstRating: worstRating,
            },
          },
        ],
      };

      addSchemaToPage(SchemaorgProduct);
    });
  });
});
//#endregion Schema.org

type sectionConfig = {
  order: number;
  margin: string;
};

const props = withDefaults(
  defineProps<{
    customerName: string;
    reviewDate: string;
    rating?: number;
    mediaList?: Array<postMedia>;
    selectedMediaThumbnailUrl?: string;
    isShowMedia?: boolean;
    negativeComment?: string;
    positiveComment?: string;
    text?: string;

    blocksOrder?: number;
    sectionsMarginTop?: Array<string>;

    topSectionConfig?: sectionConfig;
    isSoftStarIcon?: boolean;
    avatarColorIndex?: number;
    authorView?: "default" | "popup";
  }>(),
  {
    isShowMedia: true,
    authorView: "default",

    topSectionConfig: () => {
      return {
        order: 0,
        margin: "0",
      };
    },
  }
);

const emit = defineEmits<{
  (e: "selectMedia", media: imageWithPostId): void;
  (e: "popupReadMoreToggle", expanded: boolean): void;
  (e: "selectReview"): void;
}>();

function selectPostWithPhoto(media: imageWithPostId) {
  emit("selectMedia", media);
}

function onReviewClick() {
  if (isPopupReview.value) {
    return;
  }

  emit("selectReview");
}

const isPopupReview = computed(() => props.authorView === "popup");
const isReadMoreExpanded = ref(false);
const isOverflowContent = ref(false);
const positiveTextRef = ref<HTMLElement | null>(null);
const negativeTextRef = ref<HTMLElement | null>(null);
const commentTextRef = ref<HTMLElement | null>(null);
const contentMainRef = ref<HTMLElement | null>(null);

function detectOverflowContent() {
  if (!isPopupReview.value) {
    const textBlocks = [
      positiveTextRef.value,
      negativeTextRef.value,
      commentTextRef.value,
    ].filter((el): el is HTMLElement => Boolean(el));

    isOverflowContent.value = textBlocks.some((el) => {
      return el.scrollHeight - el.clientHeight > 1;
    });
    return;
  }

  const contentEl = contentMainRef.value;
  if (!contentEl) {
    isOverflowContent.value = false;
    return;
  }

  isOverflowContent.value = contentEl.scrollHeight > 432;
}

onMounted(() => {
  nextTick(detectOverflowContent);
  window.addEventListener("resize", detectOverflowContent);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", detectOverflowContent);
});

watch(
  () => [
    props.customerName,
    props.reviewDate,
    props.positiveComment,
    props.negativeComment,
    props.text,
    props.authorView,
  ],
  () => {
    isReadMoreExpanded.value = false;
    if (isPopupReview.value) {
      emit("popupReadMoreToggle", false);
    }
    nextTick(detectOverflowContent);
  },
  { deep: true }
);

//#region unique product links
type ProductLinkInfo = {
  link: string;
  title: string;
};
const uniqueProductLinks = ref<Array<ProductLinkInfo>>([]);
onBeforeMount(() => {
  uniqueProductLinks.value = getUniqueProductLinks();
});

watch(
  () => props.mediaList,
  () => {
    uniqueProductLinks.value = getUniqueProductLinks();
  }
);

function getUniqueProductLinks(): Array<ProductLinkInfo> {
  const uniqueLinks: Array<ProductLinkInfo> = [];
  const uniqueLinksInStringifyFormat = new Set<string>();

  props.mediaList?.forEach((media) => {
    media.linkList.forEach((link) => {
      const productInfo = {
        link: link.link,
        title: link.title,
      };

      uniqueLinksInStringifyFormat.add(JSON.stringify(productInfo));
    });
  });

  uniqueLinksInStringifyFormat.forEach((linkInStringifyFormat) => {
    uniqueLinks.push(JSON.parse(linkInStringifyFormat));
  });

  return uniqueLinks;
}
//#endregion unique product links
</script>
